<div>
  <div class="opcode">
    <div class="opcode-name">
      <span *ngIf="!item?.isInternalCode">{{item.opcode}} | </span>
      <span>{{item?.displayName ? item?.displayName : item.dmsDescription}}</span>


      <mat-icon class="material-icons recommended-icon" *ngIf="item.recommended.isRecommended"
        [matTooltip]="'opcodeServiceManagement.recommended' | translate">thumb_up</mat-icon>
      <span *ngIf="item.isVisible" [matTooltip]="'opcodeServiceManagement.serviceIsOnline' | translate" class="status"
        matTooltipClass="asp-custom-tooltip"></span>
    </div>
  </div>
</div>